/**
 * package: com.inq.utils
 * class: Dictionary
 * root Object
 * @constructor
 */
com.inq.utils.Dictionary = function(weakKeys) {
};
$hxClasses['com.inq.utils.Dictionary'] = com.inq.utils.Dictionary;
/** @private @type {Array} */
com.inq.utils.Dictionary.__name__ = ["com","inq","utils","Dictionary"];
/** @type {com.inq.utils.Dictionary} */
com.inq.utils.Dictionary.prototype.__class__ = com.inq.utils.Dictionary;
